import CrudManager from '@/components/admin/CrudManager';

const CATEGORIES = [
    'General',
    'Employment',
    'Career Guidance',
    'Education',
    'Health',
    'Environment',
    'Disaster Relief',
    'Volunteer',
    'Events',
];

const fields = [
    { key: 'title', label: 'Album title', type: 'text' },
    { key: 'caption', label: 'Caption', type: 'text' },
    {
        key: 'category',
        label: 'Category',
        type: 'select',
        options: CATEGORIES.map((c) => ({ value: c, label: c })),
    },
    { key: 'cover_image', label: 'Cover image', type: 'upload-image', prefix: 'gallery/covers' },
    { key: 'photos', label: 'Photos', type: 'images-list', prefix: 'gallery/photos' },
    { key: 'videos', label: 'Videos (YouTube/Vimeo)', type: 'videos-list' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'title', label: 'Album', primary: true },
    { key: 'category', label: 'Category' },
    { key: 'photos', label: 'Photos', render: (r) => (r.photos || []).length },
    { key: 'videos', label: 'Videos', render: (r) => (r.videos || []).length },
    { key: 'order', label: 'Order' },
];

const defaultItem = {
    title: '',
    caption: '',
    category: 'General',
    cover_image: '',
    photos: [],
    videos: [],
    order: 99,
};

export default function AdminGalleryAlbumsPage() {
    return (
        <CrudManager
            resource="gallery-albums"
            title="Gallery Albums"
            description="Group photos and videos by event or theme. Each album shows on the public Gallery page as a card that expands into a photo + video viewer."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'category']}
        />
    );
}
